import { z } from 'zod';

import { requiredString } from '../base.schema';
import { zObjectId } from '../mongo.schema';

export const categorySchemaRef = 'Category';

export const categorySchema = z
	.object({
		id: zObjectId.meta({
			description: 'Unique identifier for the category.',
			example: 'as67saf8as7f9h98',
		}),
		name: requiredString('schemaAttributes.name').meta({
			description: 'Name of the category.',
			example: 'Plants',
		}),
		description: z.string().optional().meta({
			description: 'Description of the category.',
			example: 'A collection of various plants and gardening supplies.',
		}),
		menuDisplay: z.boolean().meta({
			description:
				'Indicates if the category should be displayed in the menu.',
			example: true,
		}),
		parentCategoryId: zObjectId.nullable().optional().meta({
			description: 'ID of the parent category.',
			example: 'as67saf8as7f9h98',
		}),
		imageId: z.string().nullable().optional().meta({
			description: 'URL of the category image.',
			example: 'https://example.com/image.jpg',
		}),
		createdAt: z
			.union([z.string().datetime('Invalid date format'), z.date()])
			.meta({
				description: 'Date and time when the category was created.',
				example: '2023-10-01T12:00:00Z',
			}),
		updatedAt: z
			.union([z.string().datetime('Invalid date format'), z.date()])
			.meta({
				description:
					'Date and time when the category was last updated.',
				example: '2023-10-01T12:00:00Z',
			}),
	})
	.meta({
		ref: categorySchemaRef,
		description: 'Schema representing a category in the system.',
	});

export type CategorySchemaType = z.infer<typeof categorySchema>;
